import { useTranslation } from 'react-i18next'

import useSessionUser from '@/modules/access/hooks/useSessionUser'
import { UtilitiesSideBarItem } from '@/modules/shared/layouts/side-navigation/purchaser-navigation/UtilitiesSideBarItem'

interface AdministrationSideBarItemsProps {
  onCloseDrawer: () => void
}

export const AdministrationSideBarItems = ({ onCloseDrawer }: AdministrationSideBarItemsProps) => {
  const { t } = useTranslation()
  const { user } = useSessionUser()

  if (!user?.isAdmin) return null

  return (
    <section className="mt-7 space-y-1.5">
      <h1 className="mb-2 px-3 text-sm text-gray-500">{t('general.administration', 'Administration')}</h1>
      <UtilitiesSideBarItem onCloseDrawer={onCloseDrawer} />
    </section>
  )
}
